export default __webpack_public_path__ + "static/media/ic_manage-sales-channel.2ec9076b.svg";